import React, { useState, useEffect, useMemo } from "react";
import {  Spin } from "antd";
import VendorRoutes from "./VendorRoutes"
import AuthRoutes from "./AuthRoutes";
import CustomerRoutes from "./CustomerRoutes";
import CustomerLayout from "../Customer/comman/master";

function AppRoutes() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [Role, setRole] = useState(null);
  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role) {
      setIsLoggedIn(true);
      setRole(role)
    } else {
      setIsLoggedIn(false);
      setRole(null);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      const disableNavigation = () => {
        window.history.pushState(null, null, window.location.href);
      };
      window.history.pushState(null, null, window.location.href);
      window.addEventListener("popstate", disableNavigation);
      return () => {
        window.removeEventListener("popstate", disableNavigation);
      };
    }
  }, [isLoggedIn]);

  const getActiveRoute = useMemo(() => {
    if (!Role) return <CustomerRoutes/>;
    switch (Role) {
      case "vendor":
        return <VendorRoutes/>;
      case "Customer":
        return <CustomerRoutes />;
      default:
        return <CustomerRoutes />;
    }
  }, [Role]);

  if (isLoading) {
    return (
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Spin />
      </div>
    );
  }

  return (
    <>
      {/* {isLoggedIn ? getActiveRoute : <AuthRoutes />} */}
      {getActiveRoute}
      
      </>
  );
}

export default AppRoutes;
